import { createAsyncThunk } from '@reduxjs/toolkit';
import { client, gql } from '~/apollo-client';
import type { AppDispatch, RootState } from '~/store';

type TAccount = {
  currentOrganization: {
    limits: {
      generateContent: number;
    };
    billing: {
      canGenerateContent: boolean;
      generateContentTokensLeft: number;
    };
  };
};

const QUERY_LIMITS = gql`
  query queryLimits {
    account {
      currentOrganization {
        limits {
          generateContent
        }
        billing {
          ... on OBBilling {
            canGenerateContent
            generateContentTokensLeft
          }
        }
      }
    }
  }
`;

const queryLimits = createAsyncThunk<
  TAccount,
  void,
  { state: RootState; dispatch: AppDispatch }
>('ai/queryTokens', async (_, { rejectWithValue }) => {
  try {
    const response = await client.query<{ account: TAccount }>({
      query: QUERY_LIMITS,
    });

    return response.data?.account;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export { queryLimits };
